import _ from 'underscore';
import Backbone from 'backbone';
import backboneRelational from '../backbone-relational-isomorphic';

var Tab = Backbone.RelationalModel.extend({

});

export default Tab;

